import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const ServiceSection = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section
      className="space bg-light shape-mockup-wrap"
      style={{ backgroundImage: "url(/assets/img/shape/Bg.png)" }}
    >
      <div
        className="shape-mockup d-none d-xl-block jump z-index-negative"
        style={{ bottom: "20%", left: "5%" }}
      >
        <img src="/assets/img/shape/Dot.png" alt="Dots" />
      </div>

      <div
        className="shape-mockup d-none d-xl-block spin z-index-negative"
        style={{ bottom: "-5%", right: "-5%" }}
      >
        <img src="/assets/img/shape/circle1.png" alt="Circle" />
      </div>

      <div
        className="shape-mockup d-none d-xl-block ripple-animation z-index-negative"
        style={{ top: "10%", left: "10%" }}
      >
        <img src="/assets/img/shape/Plane.png" alt="Plane" />
      </div>

      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
            <div className="title-area">
              <span className="sec-subtitle">
                Our Expertise at Your Service
              </span>
              <h2 className="sec-title h1">
                Explore Our Comprehensive Services
              </h2>
            </div>
          </div>
        </div>

        <Slider {...settings} className="row vs-carousel custom-slider">
          <div className="col-xl-3 col-md-6 col-sm-6 col-12">
            <div className="features-style3">
              <div
                className="features-bg"
                style={{
                  backgroundImage: "url(/assets/img/shape/features2.png)",
                }}
              ></div>
              <div className="features-image">
                <img src="/assets/img/flaticon/hotel.png" alt="" />
              </div>
              <div className="features-content" style={{ height: "230px" }}>
                <h3 className="features-title">Holiday Home Rentals</h3>
                <p className="features-text">
                  Short-term and long-term holiday home rentals, fully furnished
                  apartments and studios.
                </p>
                <Link className="features-link" to="/contact">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 1C12 0.447716 11.5523 5.87248e-07 11 1.00872e-06L2 4.60808e-07C1.44771 7.97982e-07 0.999999 0.447716 0.999999 1C1 1.55229 1.44771 2 2 2L10 2L10 10C10 10.5523 10.4477 11 11 11C11.5523 11 12 10.5523 12 10L12 1ZM1.70711 11.7071L11.7071 1.70711L10.2929 0.292894L0.292893 10.2929L1.70711 11.7071Z"
                      fill="white"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xl-3 col-md-6 col-sm-6 col-12">
            <div className="features-style3">
              <div
                className="features-bg"
                style={{
                  backgroundImage: "url(/assets/img/shape/features2.png)",
                }}
              ></div>
              <div className="features-image">
                <img src="/assets/img/flaticon/flight-ticket.png" alt="" />
              </div>
              <div className="features-content" style={{ height: "230px" }}>
                <h3 className="features-title">Guest Support & Maintenance</h3>
                <p className="features-text">
                  24/7 guest support, maintenance, and housekeeping services for
                  a seamless stay.
                </p>
                <Link className="features-link" to="/contact">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 1C12 0.447716 11.5523 5.87248e-07 11 1.00872e-06L2 4.60808e-07C1.44771 7.97982e-07 0.999999 0.447716 0.999999 1C1 1.55229 1.44771 2 2 2L10 2L10 10C10 10.5523 10.4477 11 11 11C11.5523 11 12 10.5523 12 10L12 1ZM1.70711 11.7071L11.7071 1.70711L10.2929 0.292894L0.292893 10.2929L1.70711 11.7071Z"
                      fill="white"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xl-3 col-md-6 col-sm-6 col-12">
            <div className="features-style3">
              <div
                className="features-bg"
                style={{
                  backgroundImage: "url(/assets/img/shape/features2.png)",
                }}
              ></div>
              <div className="features-image">
                <img src="/assets/img/flaticon/virtual-tour.png" alt="" />
              </div>
              <div className="features-content" style={{ height: "230px" }}>
                <h3 className="features-title">Airport Pickup & Drop-off</h3>
                <p className="features-text">
                  Convenient airport pick-up and drop-off assistance (upon
                  request) for a hassle-free experience.
                </p>
                <Link className="features-link" to="/contact">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 1C12 0.447716 11.5523 5.87248e-07 11 1.00872e-06L2 4.60808e-07C1.44771 7.97982e-07 0.999999 0.447716 0.999999 1C1 1.55229 1.44771 2 2 2L10 2L10 10C10 10.5523 10.4477 11 11 11C11.5523 11 12 10.5523 12 10L12 1ZM1.70711 11.7071L11.7071 1.70711L10.2929 0.292894L0.292893 10.2929L1.70711 11.7071Z"
                      fill="white"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xl-3 col-md-6 col-sm-6 col-12">
            <div className="features-style3">
              <div
                className="features-bg"
                style={{
                  backgroundImage: "url(/assets/img/shape/features2.png)",
                }}
              ></div>
              <div className="features-image">
                <img src="/assets/img/flaticon/transportation.png" alt="" />
              </div>
              <div className="features-content" style={{ height: "230px" }}>
                <h3 className="features-title">Customized Tour Packages</h3>
                <p className="features-text">
                  Tailored tour packages to explore the best destinations with
                  ease and comfort.
                </p>
                <Link className="features-link" to="/contact">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 1C12 0.447716 11.5523 5.87248e-07 11 1.00872e-06L2 4.60808e-07C1.44771 7.97982e-07 0.999999 0.447716 0.999999 1C1 1.55229 1.44771 2 2 2L10 2L10 10C10 10.5523 10.4477 11 11 11C11.5523 11 12 10.5523 12 10L12 1ZM1.70711 11.7071L11.7071 1.70711L10.2929 0.292894L0.292893 10.2929L1.70711 11.7071Z"
                      fill="white"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default ServiceSection;
